module.exports = __webpack_public_path__ + "static/media/H_off.cb7123d5.svg";